// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AlertWebhookFormat } from "./Shared.AlertWebhookFormat.gen";
import { AlertSeverity } from "./Shared.AlertSeverity.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsNotEmpty, IsOptional, MaxLength } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IAlertWebhook {
	id: string | undefined;

	organizationId: string | undefined;

	name: string;

	url: string;

	signingSecret: string | undefined;

	format: AlertWebhookFormat;

	minSeverity: AlertSeverity;

	isActive: boolean;

	lastSuccessAtUtc: string | undefined;

	lastFailureAtUtc: string | undefined;

	lastFailureMessage: string | undefined;

	consecutiveFailureCount: number;

	createdAtUtc: string | undefined;

	$type?: string | undefined;
}
export class AlertWebhook {
	constructor(data?: IAlertWebhook) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastSuccessAtUtc) { this.lastSuccessAtUtc = new Date(data.lastSuccessAtUtc); }
		if (data.lastFailureAtUtc) { this.lastFailureAtUtc = new Date(data.lastFailureAtUtc); }
		if (data.createdAtUtc) { this.createdAtUtc = new Date(data.createdAtUtc); }
	}

	id: string | undefined;

	organizationId: string | undefined;

	@IsNotEmpty()
	@MaxLength(128)
	name: string = "";

	@IsNotEmpty()
	@MaxLength(1024)
	url: string = "";

	@IsOptional()
	@MaxLength(128)
	signingSecret: string | undefined;

	format: AlertWebhookFormat = 0;

	minSeverity: AlertSeverity = 0;

	isActive: boolean = false;

	lastSuccessAtUtc: Date | undefined;

	lastFailureAtUtc: Date | undefined;

	@IsOptional()
	@MaxLength(512)
	lastFailureMessage: string | undefined;

	consecutiveFailureCount: number = 0;

	createdAtUtc: Date | undefined = new Date();

	static $type: string = "CoreApi.Models.Alerts.AlertWebhook, ";
	$type?: string | undefined = AlertWebhook.$type;
}

